import { SimilarDesignItem } from '@app/data/clients/rbServerSideClient/queries/GetSimilarDesigns/types';
import {
  CategorySetDefaultInventoryItem,
  InventoryItem,
} from '@app/types/shop-bff/types';

export const getOffsiteCarouselFirstItem = (
  currentInventoryItem: InventoryItem,
  defaultItem: CategorySetDefaultInventoryItem,
  isOffsiteVisitor: boolean
) => {
  if (isOffsiteVisitor) {
    return {
      inventoryItemId: currentInventoryItem.id,
      inventoryItem: {
        ...currentInventoryItem,
        /**
         * we get the pathname of the productPageUrl above, we are only using the pathname here so
         * we can ignore the baseUrl so it works on any environment
         */
        productPageUrl: new URL(currentInventoryItem.productPageUrl || '')
          ?.pathname,
        work: {
          ...defaultItem.work,
        },
        // need to cast here as currentInventoryItem and SimilarDesignItem are functionally the same but have different __typenames
      } as SimilarDesignItem['inventoryItem'],
    };
  }
  return null;
};
